import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoggerService } from '@rms/core/logger/logger.service';
import { environment } from '@rms/env';
import { catchError, throwError } from 'rxjs';

export const LOG_CONTEXT = new HttpContextToken<string>(() => '');

export const errorLoggingInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const path = stripQuery(req.url);
      const context = req.context.get(LOG_CONTEXT) || `${req.method} ${path}`;
      logger.error(buildErrorPayload(req, error, path), `${context} → ${error.status}`);

      return throwError(() => error);
    })
  );
};

function buildErrorPayload(req: HttpRequest<unknown>, error: HttpErrorResponse, path: string): unknown {
  if (!environment.production) {
    return error;
  }

  return {
    method: req.method,
    status: error.status,
    statusText: error.statusText,
    path,
  };
}

function stripQuery(url: string): string {
  const queryIndex = url.indexOf('?');

  return queryIndex === -1 ? url : url.slice(0, queryIndex);
}
